import * as ActionTypes from '../constants/actionTypes';
import { userService } from '../services/userService';

import { toast } from 'react-toastify';

import {getErrorMessage} from '../utils/error-parser';
import { authToken } from '../utils/auth-header';

export const userActions = {
    login,
    getUserDetails,
    logout,
    createUser,
    createUserAndGetUserDetail,
    reset
};

function logout() {
    return (dispatch, getState)=>{
        if(getState().authentication.loggedIn){
            userService.logout();
            dispatch(request());
            dispatch(removePaymentDetail());
        }
    };
    function request() { return { type: ActionTypes.LOGOUT }; }
    function removePaymentDetail() { return { type: ActionTypes.RESET_PAYMENT_DETAILS }; }
   
}

function reset(){
    return (dispatch)=>{

        dispatch(request());
        
    };
    function request() { return { type: ActionTypes.RESET }; }
}

function login(username, password,accountId) {
    return dispatch => {
        dispatch(request());
         return userService.login(username, password,accountId)
            .then((response) => { 
                let data = response.data;
                if(data.authorization.multipleAccount && accountId == ''){
                    toast.info("Multiple accounts are associated with this email address, please login with using the account number.", {
                        autoClose: 10000,
                        hideProgressBar: false
                    });
                    return;
                    
                } else {
                    dispatch(success(data));
                    localStorage.setItem('user', JSON.stringify(data));
                }
               
            })
            .catch(error => {
                if (error.response) {
                    dispatch(failure(error.response.data));
                } else {
                    dispatch(failure(error));
                }
            });
    };

    function request() { return { type: ActionTypes.LOGIN_REQUEST }; }
    function success(user) { return { type: ActionTypes.LOGIN_SUCCESS, user }; }
    function failure(error) {
        console.log('error, ', error.errors);
        let msg = (error.errors[0] ? error.errors[0] : "Failed to login");

        toast.error(msg, {
            autoClose: 10000,
            hideProgressBar: false
        });
        return { type: ActionTypes.LOGIN_FAILURE, error };
    }
}

function getUserDetails() {
    return dispatch => {
            dispatch(request());
            userService.getUser()
            .then((response) => {
                let userData = response.data;
                dispatch(success(userData));
            })
            .catch(error => {
                dispatch(failure(error));
            });
        };
    function request() { return { type: ActionTypes.GET_USER_DETAILS_REQUEST }; }
    function success(data) { return { type: ActionTypes.GET_USER_DETAILS_SUCCESS, data }; }
    function failure(error) {
        console.error("Unable to retrieve user details.", error);
        // toast.error("Unable to retrieve user details.", {
        //     autoClose: 10000,
        //     hideProgressBar: false
        // });
        return { type: ActionTypes.GET_USER_DETAILS_FAILURE, error };
    }
}
function createUser(accountDetail) {
    return dispatch => {
        dispatch(request());
        let user = {
            email: accountDetail.email,
            password: accountDetail.password,
            firstName: accountDetail.firstName,
            lastName: accountDetail.lastName,
            phone: accountDetail.phone,
            tcAccepted: accountDetail.tcAccepted,
            privacyAccepted: true
        };
        return userService.createUser(user)
        .then((response) => {
                let userData = response.data;

                dispatch(success(userData));
                localStorage.setItem('user', JSON.stringify(userData));
        })
        .catch(error => {
            dispatch(failure(error));
            throw error;
        });
    };

    function request() { return { type: ActionTypes.CREATE_USER_REQUEST }; }
    function success(data) { return { type: ActionTypes.CREATE_USER_SUCCESS, data }; }
    function failure(error) {
        toast.error(getErrorMessage(error.response.data.errorCode), {
            autoClose: 10000,
            hideProgressBar: false
        });
        return { type: ActionTypes.CREATE_USER_FAILURE, error };
    }
}

function createUserAndGetUserDetail(accountDetail){
    return (dispatch) => {
        return dispatch(createUser(accountDetail))
        .then(() => {
            if(authToken())
                return dispatch(getUserDetails());
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/userActions.js